import { Injectable } from '@angular/core';
import { KRONOS } from '../../../app-constants';
import { API } from '../../../constants/index';
import { DataService } from '../core/interceptor.service';

@Injectable()
export class TimeEkstepService {
  info: any = [];

  constructor(private dataService: DataService) { }

  saveTaskActivity(taskActivity) {
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.SAVE_TASK_FOR_PROJECT_FEATURE, taskActivity);
  }

  updateTaskActivity(taskActivity) {
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.UPDATE_TASK_FOR_PROJECT_FEATURE, taskActivity);
  }
  deleteTaskActivity(taskActivity) {
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.DELETE_TASK_FOR_PROJECT, taskActivity);
  }

  getWeekActivity(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.USER + API.GET_WEEK_ACTIVITY_EKSTEP, req);
  }
}
